import { useAppSelector } from "../../store/hooks";
import style from "./SpecialChanceBoard.module.css";

interface SpecialChanceBoardProps {
  withDescription?: boolean;
}

const SpecialChanceBoard = ({ withDescription }: SpecialChanceBoardProps) => {
  const user = useAppSelector((state) => state.login.user.data?.data?.user);
  return (
    <div className={style.information}>
      <div className={style["information-inner"]}>
        <div className={style.informationAll}>
          <p>تعداد شانس ویژه دریافت شده:</p>
          <div>
            <span>{user?.total_special_invite_chance} </span>
            <span>شانس</span>
          </div>
        </div>
        <div className={style["information-title"]}>
          <div>
            <span> دوست بانی‌مدی </span>
          </div>
          <div>
            <span>دوست غیر بانی‌مدی</span>
          </div>
        </div>
        <div className={style["information-items"]}>
          <div className={style["information-item"]}>
            <span className={style["information-item-number"]}>
              {user?.banimode_users_count!}
            </span>
            <span className={style["information-item-leter"]}>نفر</span>
          </div>
          <div className={style["information-line"]}></div>
          <div className={style["information-item"]}>
            <span className={`${style["information-item-number"]}`}>
              {user?.new_users_count!}
            </span>
            <span className={style["information-item-leter"]}>نفر</span>
          </div>
        </div>
        {withDescription ? (
          <div className={style["description"]}>
            <p>
              برای چرخوندن گردونه جوایز ویژه بانی‌مد حتما باید "شانس ویژه" داشته
              باشی که فقط از طریق دعوت دوست به بازی به دست میاد.
            </p>
            <p>
              با دعوت از هر دوست غیربانی‌مدی 5 شانس بازی و 5 شانس ویژه دریافت
              می‌کنی.
            </p>
            <p>
              با دعوت از هر دوست بانی‌مدی 2 شانس بازی و 2 شانس ویژه دریافت
              می‌کنی.
            </p>
            <p>
              دوست بانی‌مدی کسیه که قبلا عضو بانی‌مد شده و دوست غیربانی‌مدی کسیه
              که عضو بانی‌مد نبوده و از طریق لینک دعوت تو به خانواده بانی‌مد
              ملحق می‌شه.
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SpecialChanceBoard;
